import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CorteItem, CorteService } from "../../services/corte.service";

type CorteCorOption = { id: number; descricao?: string | null };

@Component({
  selector: "app-corte-form",
  templateUrl: "./corte-form.component.html",
  styleUrls: ["./corte-form.component.css"],
})
export class CorteFormComponent {
  private _editando: CorteItem | null = null;

  @Input()
  set editando(v: CorteItem | null) {
    this._editando = v;
    if (v) {
      this.qtdStr = String(v.qtd);
      this.compStr = v.comprimento_util.toFixed(2).replace(".", ",");
      this.erro = null;
    } else {
      this.qtdStr = "1";
      this.compStr = "";
      this.erro = null;
    }
  }
  get editando(): CorteItem | null {
    return this._editando;
  }

  @Input() cores: CorteCorOption[] = [];
  @Input() tamanhos: string[] = [];

  @Input() corSelecionada: number | null = null;
  @Output() corSelecionadaChange = new EventEmitter<number>();

  @Input() tamanhoSelecionado: string | null = null;
  @Output() tamanhoSelecionadoChange = new EventEmitter<string>();

  @Output()
  adicionar = new EventEmitter<{
    qtd: number;
    comprimento_util: number;
    cor?: number | null;
    tamanho?: string | null;
  }>();
  @Output() cancelarEdicao = new EventEmitter<void>();

  /** Desabilita o formulário enquanto o POST v2/pedido/itens está em andamento. */
  @Input() bloqueado = false;

  qtdStr = "1";
  compStr = "";
  erro: string | null = null;

  constructor(private corte: CorteService) {}

  get mostrarSelectCor(): boolean {
    return Array.isArray(this.cores) && this.cores.length > 1;
  }

  get mostrarSelectTamanho(): boolean {
    return Array.isArray(this.tamanhos) && this.tamanhos.length > 1;
  }

  onCorChange(v: any): void {
    const n = Number(v);
    if (Number.isFinite(n)) {
      this.corSelecionadaChange.emit(n);
    }
  }

  onTamanhoChange(v: any): void {
    const s = String(v ?? "").trim();
    if (s) {
      this.tamanhoSelecionadoChange.emit(s);
    }
  }

  get qtdInt(): number {
    const n = Number.parseInt(String(this.qtdStr), 10);
    return Number.isInteger(n) && n >= 1 ? n : 1;
  }

  /** Valor numérico do comprimento ou null se vazio/ inválido. */
  get compNumero(): number | null {
    const raw = (this.compStr ?? "").trim();
    if (!raw) {
      return null;
    }
    const v = Number(raw.replace(",", "."));
    return Number.isFinite(v) ? v : null;
  }

  incrementQtd(): void {
    if (this.bloqueado) {
      return;
    }
    this.qtdStr = String(this.qtdInt + 1);
    this.limparErroSomenteQuantidade();
  }

  decrementQtd(): void {
    if (this.bloqueado) {
      return;
    }
    if (this.qtdInt > 1) {
      this.qtdStr = String(this.qtdInt - 1);
    }
    this.limparErroSomenteQuantidade();
  }

  incrementComp(): void {
    if (this.bloqueado) {
      return;
    }
    const base = this.compNumero ?? 0;
    const next = Math.round((base + 0.1) * 100) / 100;
    this.compStr = next.toFixed(2).replace(".", ",");
    this.onCompChange();
  }

  decrementComp(): void {
    if (this.bloqueado) {
      return;
    }
    const v = this.compNumero;
    if (v === null) {
      return;
    }
    if (v <= 0.1) {
      this.compStr = "";
      this.erro = null;
      return;
    }
    const next = Math.round((v - 0.1) * 100) / 100;
    this.compStr = next.toFixed(2).replace(".", ",");
    this.onCompChange();
  }

  limparErroSomenteQuantidade(): void {
    if (
      this.erro === "Quantidade deve ser inteira e maior ou igual a 1."
    ) {
      this.erro = null;
    }
  }

  onCompChange(): void {
    const raw = (this.compStr ?? "").trim();
    if (!raw) {
      this.erro = null;
      return;
    }
    const v = Number(raw.replace(",", "."));
    if (!Number.isFinite(v)) {
      this.erro = "Comprimento inválido.";
    } else if (v <= 0) {
      this.erro = "O comprimento deve ser maior que zero.";
    } else if (!this.corte.isMultiploDe10cm(v)) {
      this.erro = "O comprimento deve ser múltiplo de 0,10 m.";
    } else {
      this.erro = null;
    }
  }

  limpar(emitirCancelar: boolean): void {
    if (this.bloqueado) {
      return;
    }
    this.qtdStr = "1";
    this.compStr = "";
    this.erro = null;
    if (emitirCancelar) {
      this.cancelarEdicao.emit();
    }
  }

  submit(): void {
    if (this.bloqueado) {
      return;
    }
    const qtd = Number.parseInt(this.qtdStr, 10);
    const comprimento_util = Number(this.compStr.replace(",", "."));

    if (!Number.isInteger(qtd) || qtd < 1) {
      this.erro = "Quantidade deve ser inteira e maior ou igual a 1.";
      return;
    }
    if (!Number.isFinite(comprimento_util) || comprimento_util <= 0) {
      this.erro = "O comprimento deve ser maior que zero.";
      return;
    }
    if (!this.corte.isMultiploDe10cm(comprimento_util)) {
      this.erro = "O comprimento deve ser múltiplo de 0,10 m.";
      return;
    }

    this.adicionar.emit({
      qtd,
      comprimento_util,
      cor: this.corSelecionada,
      tamanho: this.tamanhoSelecionado,
    });
  }
}
